export const DEFAULT_SOLANA_EXPLORER = `https://solscan.io/`;
